import React from 'react';

import './styles.css';

export const RadioButton = ({ label, id, value, ...props }) => {
  return (
    <label className="hide-radio d-flex" htmlFor={id}>
      <input type="radio" id={id} {...props} value={value} />
      <span className="radio_button_container">{label}</span>
    </label>
  );
};
